import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    width: 100%;
    position: relative;

    .border {
        display: block;
        height: .2em;
        width: 100%;
        max-width: 3.5em;
        box-shadow: 0 -.1em 0 0 #C09E4B;
        margin-bottom: .5em;
    }

    .list-search {
        margin-bottom: 2em;

        .layout-forms-input {
            .layout-forms-input-wrapper {
                .label-wrapper {
                    display: none;
                }

                .internal-wrapper {
                    border: .1em solid #D3D4D3;
                    border-radius: .6em;

                    .input-body {
                        .input {
                            height: 3em;

                            ::placeholder {
                                color: #C1C1C1;
                            }
                        }
                    }

                    .input-decorator {
                        cursor: pointer;
                        padding: 0;

                        a {
                            padding: 0.5em;

                            svg {
                                width: 1em;
                            }

                            @media (pointer: fine) {
                                &:hover {
                                    svg {
                                        color: black;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .list-header {
        font-size: .9em;
        font-weight: 700;
        color: #262626;
    }

    .list-body {
        margin-top: .8em;

        .list-element {
            font-size: .8em;
            color: #262626;
            padding-bottom: .5em;
            margin-right: 1em;
            cursor: pointer;
            white-space: nowrap;

            &:hover {
                color: #C1C1C1;
            }
        }

        .list-element-bold {
            font-weight: 700;
        }
    }

    @media all and (max-width: ${variables.tabletL}) {
    }
`;
